import { render, staticRenderFns } from "./AstroCalendarNoteList.vue?vue&type=template&id=ca2c6d5a&"
import script from "./AstroCalendarNoteList.vue?vue&type=script&lang=js&"
export * from "./AstroCalendarNoteList.vue?vue&type=script&lang=js&"
import style0 from "./AstroCalendarNoteList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca2c6d5a')) {
      api.createRecord('ca2c6d5a', component.options)
    } else {
      api.reload('ca2c6d5a', component.options)
    }
    module.hot.accept("./AstroCalendarNoteList.vue?vue&type=template&id=ca2c6d5a&", function () {
      api.rerender('ca2c6d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/共時曆/AstroCalendarNoteList.vue"
export default component.exports